// eslint-disable-next-line @typescript-eslint/no-unused-vars
import * as React from 'react';

const TITLE = 'QR Code';

export function QR() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      aria-label={TITLE}
      role="img"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{TITLE}</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM10 8H8V10H10V8ZM7 7V11H11V7H7ZM8 14H10V16H8V14ZM7 17V13H11V17H7ZM16 8H14V10H16V8ZM13 7V11H17V7H13ZM17 13H13V17H14V14H17V13Z"
        fill="currentColor"
      />
    </svg>
  );
}
